import { cn } from "@faire/web--source/tools/cn";
import React, { type JSX } from "react";

interface ShimmerPlaceHolderProps {
  className?: string;
  $height?: number;
  $width?: number;
  $aspectRatio?: number;
  $backgroundColor?: string;
}

export const ShimmerPlaceHolder = ({
  className,
  $height,
  $width,
  $aspectRatio,
  $backgroundColor,
}: ShimmerPlaceHolderProps): JSX.Element => {
  return (
    <div
      className={cn(
        "bg-core-surface-subdued shimmer relative flex overflow-hidden",
        className
      )}
      style={{
        height: $height ? `${$height}px` : "100%",
        width: $width ? `${$width}px` : "100%",
        aspectRatio: $aspectRatio ? `${$aspectRatio}` : "",
        backgroundColor: $backgroundColor,
      }}
    />
  );
};
